import { Controller } from "@hotwired/stimulus"

// Disables the buttons/submits it wraps while the browser is offline, and only
// re-enables the ones it disabled (never those disabled for other reasons).
export default class extends Controller {
  connect() {
    this._onOnline  = () => this.#enable()
    this._onOffline = () => this.#disable()
    window.addEventListener("online",  this._onOnline)
    window.addEventListener("offline", this._onOffline)
    this.element.dataset.offlineGateReady = ""
    if (!navigator.onLine) this.#disable()
  }

  disconnect() {
    window.removeEventListener("online",  this._onOnline)
    window.removeEventListener("offline", this._onOffline)
  }

  #disable() {
    this._disabledByGate = new Set()
    this.element.querySelectorAll("button, input[type=submit]").forEach(el => {
      if (!el.disabled) {
        el.disabled = true
        this._disabledByGate.add(el)
      }
    })
  }

  #enable() {
    if (!this._disabledByGate) return
    this._disabledByGate.forEach(el => { el.disabled = false })
    this._disabledByGate = null
  }
}
